import { Injectable } from '@angular/core';
import { WorkspaceRepository } from '@database/central';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared';
import { LoggingService } from '@shared/logging';
import { WorkspaceDatabaseProvider } from '../workspace-database.provider';
import { DynamicSchemaService } from './dynamic-schemas.service';
@Injectable()
export class RestoreDatabaseService {
	public constructor(
		private workspaceDatabase: WorkspaceDatabaseProvider,
		private configDbWorkspaceRepo: WorkspaceRepository,
		private dynamicSchemaService: DynamicSchemaService,
		private logggingService: LoggingService,
		private alertService: AlertService,
		private translateService: TranslateService
	) {}

	public isDatabaseInitialized(databaseName: string): boolean {
		return this.workspaceDatabase.isActiveDatabase(databaseName);
	}

	public async setActiveWorkfileDatabase(databaseName: string): Promise<void> {
		const database = await this.workspaceDatabase.initializeDatabase(databaseName);

		try {
			await this.dynamicSchemaService.resetDataTablesCollectionsFromLocal(database);
		} catch (error) {
			await this.alertService.presentAlert(
				this.translateService.instant('importPage.restartRequired'),
				[],
				false
			);
			this.logggingService.error('RestoreDatabaseService', error);
			//todo: add translations if this will be the solution
		}
	}

	public async worfileExists(workfileId: string): Promise<boolean> {
		return await this.configDbWorkspaceRepo.exists(workfileId);
	}
}
